"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    meta: {
        title: 'Criar Cadastro | Minha Loja Digital',
        description: 'Informe seus dados e fique por dentro das novidades da loja do seu revendedor.',
    },
    header: {
        securityDisclaimer: 'Ambiente seguro',
    },
    paymentLinkForm: {
        header: {
            title: 'Olá! Informe seus dados e fique por dentro das novidades ##catalogName##.',
            catalogNameFallback: 'do seu revendedor',
        },
        mandatoryFields: '* Campos obrigatórios',
        fields: {
            fullName: {
                labelText: 'Nome Completo',
                invalidMessages: {
                    required: 'Por favor, informe nome e sobrenome.',
                    validate: 'Por favor, informe nome e sobrenome.',
                },
            },
            documentNumber: {
                labelText: 'CPF',
                placeholder: '000.000.000-00',
                invalidMessages: {
                    required: 'Por favor, informe o seu CPF.',
                    validate: 'Por favor, informe um CPF válido.',
                },
            },
            email: {
                labelText: 'E-mail',
                invalidMessages: {
                    required: 'Por favor, informe um e-mail.',
                    validate: 'Por favor, informe um e-mail válido.',
                },
            },
            phoneNumber: {
                labelText: 'Celular',
                placeholder: '(__) _____-____',
                invalidMessages: {
                    required: 'Por favor, informe um celular com DDD.',
                    validate: 'Por favor, informe um celular com DDD.',
                },
            },
            optIns: {
                labelText: 'Quero receber comunicações, novidades e informações ##catalogName##.',
                catalogNameFallback: 'da loja do revendedor',
                invalidMessages: {},
            },
        },
        callToAction: 'Continuar',
        skipSignupCallToAction: 'Continuar sem identificação',
    },
    termsAndConditions: {
        content: 'Em respeito à privacidade, tratamos as suas informações pessoais de acordo com os nossos ##terms## e a nossa ##privacy##',
        links: [
            {
                token: '##terms##',
                content: 'Termos e Condições',
                link: {
                    title: 'Faça download dos Termos e Condições.',
                    href: 'https://meucatalogodigitalresources.grupoboticario.digital/assets/pdfs/termos-de-uso.pdf',
                    download: 'termos-de-uso-minha-loja-digital.pdf',
                },
            },
            {
                token: '##privacy##',
                content: 'Política de Privacidade',
                link: {
                    title: 'Clique para saber mais sobre a política de privacidade do Grupo Boticário',
                    href: 'https://privacidade.grupoboticario.com.br/',
                    target: '_blank',
                },
            },
        ],
    },
};
